import React from 'react';
import styles from './ConquerSection.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const ConquerSection = () => {
  return (
    <section className={cx('conquer')}>
      <div className={cx('conquer-intro')}>
        <h2>よりよい空気を</h2>
        <p><span lang='en-thin'>Awair</span>はアメリカの有名な<span lang='en-thin'>Mayo</span>クリニックと提携し、空気を改善するためのアイディアも教えてくれます。</p>
      </div>
      <div className={cx('conquer-phone')}>
        <div className={cx('iphone')} />
        <div className={cx('iphone-shadow')} />
      </div>
    </section>
  );
};

export default ConquerSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/ConquerSection/ConquerSection.js